import React, { useEffect } from 'react';
import './Robot.css'

function Robot() {

  useEffect(() => {
    document.querySelector('body').style.backgroundColor = '#9fbaa1'
  }, []);

  return (
    <div className="RobotPage" >
      <h1 className="Title" >Robotics</h1>
      <div className="RobotInfo">
        <p>
          We are currently building an embodied robot to aid in Blackfoot
          Learning.
        </p>
        <p> We will be using Pepper as our robot teacher!</p>
        <p>Pepper's motions and tablet will help create an immersive
          experience using the student's own imagination to immerse them in
          Blackfoot language and culture.</p>
      </div>
    </div>
  );
}

export default Robot;
